'use client';

import { LockedModule } from '../_components/LockedModule';

export default function ReviewsPage() {
  return (
    <LockedModule
      tier="Pro"
      title="ביקורות מלקוחות"
      description="אספו ביקורות אוטומטית לאחר כל תור ובנו את המוניטין שלכם. זמין בתוכנית Pro."
    />
  );
}
